import React, { useContext, useEffect } from 'react';
import { IsMobileBiggerWidth } from 'core/util/WindowSize';
import GlobalStyled from '../../AcessoExlusivo.style';
import { AcessoExclusivoContext } from 'pages/acessoExclusivo/context/AcessoExclusivoContext';
import Loading from 'components/Loading';
import OverviewExclusivo from '../components/OverviewExclusivo';
import CicloExclusivo from '../components/CicloExclusivo';
import formulaLogo from './../../../../images/solutions/logo/formulaDaVitoriaLogo.png';
import MateriaisExclusivos from '../components/MateriasExclusivos';
import { ListMateriasFVPortuguesPlanoAnual } from './ListMateriasFVPortugues';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import UsuarioDTO from 'models/UsuarioDTO';
import { useAppSelector } from 'hooks/LocalReduxThunk';
import SessionFerramentaVideo from 'pages/acessoExclusivo/components/SessionFerramentaVideo';

const FormulaDaVitoriaPortuguesPrivate = () => {
    const { loading, idsMyCategorias } = useContext(AcessoExclusivoContext.Context);
    const isMobile = IsMobileBiggerWidth();
    const usuarioLogado: UsuarioDTO = useAppSelector(state => state.authenticationReducer.usuarioLogado);

    const naoTemCategoria1e2 = !idsMyCategorias.includes(1);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <GlobalStyled.GlobalContainer isMobile={isMobile}>
            {loading ? (
                <>
                    <Loading />
                </>
            ) : (
                <>
                    <OverviewExclusivo
                        isBlue
                        mencao={
                            [2, 3, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Ministério da Cultura apresenta o projeto Plano Anual Instituto Ayrton Senna.'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Ministério da Cultura apresenta o projeto Apoio Cultural e Educacional para Escolas das Redes Públicas Estadual e Municipal do Instituto Ayrton Senna.'
                                : ''
                        }
                        title="Fórmula da Vitória Língua Portuguesa"
                        img="ExclusivoFormulaPortImagem1.jpg"
                        logo={formulaLogo}
                        arquivo={'FV_Materiais_2026/LINGUA PORTUGUESA/VISÃO GERAL SISTEMÁTICA E DIRETRIZES/Visão geral_Fórmula da Vitória.pdf'}
                        nome_arquivo="Formula_Vitoria_Port_Visao_Geral"
                        description={`
                          O <b>Fórmula da Vitória Língua Portuguesa</b> tem como objetivo promover o desenvolvimento integral dos estudantes que chegaram aos anos finais do Ensino Fundamental 
                          com defasagens importantes em leitura, escrita e compreensão textual.
                          </br> </br>
                          A proposta busca: </br>
                          <ol style="list-style: inside disc;">
                            <li>Qualificar a linguagem oral e escrita dos alunos em diferentes contextos de comunicação;</li>
                            <li>Ampliar a capacidade linguístico-discursiva, desenvolvendo o domínio dos elementos estruturais e funcionais dos gêneros textuais mais presentes no cotidiano escolar e social.</li>
                          </ol>
                          </br>
                          Acesse o documento de visão geral e conheça melhor os caminhos para fortalecer as aprendizagens em Língua Portuguesa.
                        `}
                        regua={
                            [2, 3, 6, 7, 8, 9].some(id => idsMyCategorias.includes(id)) || usuarioLogado.email.includes('@ias')
                                ? 'Reguas_Logo/2026_Regua_Plano_Anual_Defeso_Eleitoral_pequena.jpg'
                                : [35].some(id => idsMyCategorias.includes(id))
                                ? 'Reguas_Logo/2026_Regua_Roanet_Disseminacao_Hor_apoio_comprimida.jpg'
                                : ''
                        }
                    />
                    <CicloExclusivo
                        title="Curso Fórmula da Vitória Língua Portuguesa"
                        description={`
                        O curso <b>Fórmula da Vitória Língua Portuguesa</b> foi criado para apoiar professores, coordenadores pedagógicos, diretores e técnicos das redes públicas na implementação da proposta. 
                        <br/> <br/>
                        Durante a formação, você vai conhecer os conteúdos essenciais da solução e se apropriar de estratégias pedagógicas que contribuem para o 
                        avanço dos estudantes nos anos finais do Ensino Fundamental. 
                        <br/> <br/>
                        <b>Vamos juntos?</b>  <br/>
                        Inicie agora o curso e fortaleça sua atuação em sala de aula! 
                         
                        `}
                        img="ExclusivoFormulaPortImagem2.jpg"
                        itens={
                            naoTemCategoria1e2
                                ? [
                                      {
                                          title: 'Curso Fórmula da Vitória Língua Portuguesa',
                                          url: '/cursos/formula-da-vitoria/formula-da-vitoria-lp?redirect=exclusivo/formula-da-vitoria-portugues',
                                          isBlock: false,
                                          titleIsBlock: `Esse curso não está disponível.`,
                                      },
                                  ]
                                : []
                        }
                    />
                    <MateriaisExclusivos
                        title="Materiais especiais para download"
                        description={`Acesse os materiais exclusivos do <b>Fórmula da Vitória Lingua Portuguesa</b> e conheça mais de perto a proposta. Eles foram pensados para apoiar sua prática e facilitar a implementação da solução na rede. `}
                        img={'anexo_storage_files_500146459835730599.jpeg_2025-03-31-1743446437587.jpeg'}
                        items={ListMateriasFVPortuguesPlanoAnual}
                    />
                    <SessionFerramentaVideo solucaoId={5} />
                    <ContactContainer />
                </>
            )}
        </GlobalStyled.GlobalContainer>
    );
};

export default FormulaDaVitoriaPortuguesPrivate;
